import React from "react";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import DashboardIcon from "@material-ui/icons/Dashboard";
import SchoolIcon from "@material-ui/icons/School";
import CreateIcon from "@material-ui/icons/Create";
import BackupIcon from "@material-ui/icons/Backup";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import PersonIcon from "@material-ui/icons/Person";
import LockIcon from "@material-ui/icons/Lock";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import Tooltip from "@material-ui/core/Tooltip";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { navigate } from "@reach/router";
import { useStore } from "../../context";
import Swal from "sweetalert2";
import logoanai from "../../images/logos/logoanai.png";

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    background: "linear-gradient(180deg, #0d1b3e 0%, #162d5a 100%)",
    color: "#fff",
    borderRight: "none",
    boxShadow: "4px 0 24px rgba(13, 27, 62, 0.18)",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 60,
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    minHeight: 64,
  },
  logoSection: {
    textAlign: "center",
    padding: "18px 16px 6px",
  },
  logoImg: {
    width: 54,
    height: "auto",
    borderRadius: "50%",
    background: "#fff",
    padding: 4,
    boxShadow: "0 2px 10px rgba(0,0,0,0.18)",
  },
  userSection: {
    padding: "14px 16px 16px",
    textAlign: "center",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },
  userAvatar: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #d4a017 0%, #e6b422 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 10px",
    boxShadow: "0 4px 12px rgba(212, 160, 23, 0.3)",
  },
  userName: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#fff",
    letterSpacing: "0.3px",
    marginBottom: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  userRole: {
    fontSize: "0.7rem",
    color: "rgba(255,255,255,0.5)",
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
  navSection: {
    flex: 1,
    padding: "16px 0",
    overflowY: "auto",
  },
  navLabel: {
    padding: "8px 20px 4px",
    fontSize: "0.65rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "1.5px",
    color: "rgba(255,255,255,0.35)",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    padding: "10px 20px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    borderRadius: "0 24px 24px 0",
    margin: "2px 12px 2px 0",
    "&:hover": {
      background: "rgba(212, 160, 23, 0.15)",
      color: "#d4a017",
    },
  },
  navItemActive: {
    background: "rgba(212, 160, 23, 0.2)",
    color: "#d4a017",
    borderLeft: "3px solid #d4a017",
  },
  navIcon: {
    marginRight: 14,
    fontSize: "1.25rem",
    opacity: 0.85,
    minWidth: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  navText: {
    fontSize: "0.85rem",
    fontWeight: 500,
    letterSpacing: "0.2px",
  },
  logoutSection: {
    padding: "12px 16px",
    borderTop: "1px solid rgba(255,255,255,0.1)",
  },
  logoutBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    width: "100%",
    padding: "10px",
    border: "1px solid rgba(255,255,255,0.15)",
    borderRadius: 10,
    background: "rgba(255,255,255,0.05)",
    color: "rgba(255,255,255,0.8)",
    cursor: "pointer",
    fontSize: "0.8rem",
    fontWeight: 600,
    transition: "all 0.2s ease",
    "&:hover": {
      background: "rgba(220, 53, 69, 0.15)",
      borderColor: "rgba(220, 53, 69, 0.4)",
      color: "#ff6b6b",
    },
  },
  /* Collapsed state overrides */
  userSectionCollapsed: {
    padding: "16px 0 12px",
  },
  navItemCollapsed: {
    justifyContent: "center",
    padding: "10px 0",
    margin: "2px 6px",
    borderRadius: 10,
  },
  navIconCollapsed: {
    marginRight: 0,
    fontSize: "1.3rem",
  },
  logoutBtnCollapsed: {
    padding: 8,
    borderRadius: "50%",
    width: 40,
    height: 40,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  userActions: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    marginTop: 10,
  },
  userActionBtn: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    padding: "5px 12px",
    borderRadius: 8,
    border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.06)",
    color: "rgba(255,255,255,0.75)",
    cursor: "pointer",
    fontSize: "0.72rem",
    fontWeight: 600,
    transition: "all 0.2s ease",
    "&:hover": {
      background: "rgba(212, 160, 23, 0.18)",
      color: "#d4a017",
      borderColor: "rgba(212, 160, 23, 0.4)",
    },
  },
  userActionBtnDanger: {
    "&:hover": {
      background: "rgba(220, 53, 69, 0.15)",
      borderColor: "rgba(220, 53, 69, 0.4)",
      color: "#ff6b6b",
    },
  },
}));

const pensionMenuItems = [
  { label: "Dashboard", icon: DashboardIcon, path: "/pension/pagos" },
  { label: "Pago de Pensiones", icon: SchoolIcon, path: "/pension/list" },
];

const inscripcionMenuItems = [
  { label: "Inscripciones", icon: CreateIcon, path: "/inscripcion/list" },
  { label: "Cargar archivos", icon: BackupIcon, path: "/inscripcion/fileUpload" },
];

const matriculaMenuItems = [
  { label: "Lista", icon: DashboardIcon, path: "/matricula/list" },
];

const getMenuItems = (type) => {
  if (type === "inscripciones") return inscripcionMenuItems;
  if (type === "matricula") return matriculaMenuItems;
  return pensionMenuItems;
};

const getSectionLabel = (type) => {
  if (type === "inscripciones") return "Inscripciones";
  if (type === "matricula") return "Matrícula";
  return "Pensiones";
};

const Menu = ({ open, setOpen, type }) => {
  const classes = useStyles();
  const { dispatch } = useStore();
  const username = sessionStorage.getItem("username") || "";
  const items = getMenuItems(type);
  const sectionLabel = getSectionLabel(type);
  const currentPath = window.location.pathname;

  const cerrarSesion = () => {
    Swal.fire({
      title: "¿Cerrar sesión?",
      text: "Se cerrará su sesión actual.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#0d1b3e",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Sí, salir",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch({ type: "REMOVE_TOKEN" });
        if (type === "inscripciones") {
          dispatch({ type: "RESET_CART_INS" });
        } else if (type === "matricula") {
          dispatch({ type: "RESET_CART_MAT" });
          dispatch({ type: "REMOVE_LOGIN" });
        } else {
          dispatch({ type: "RESET_CART" });
        }
        dispatch({ type: "REMOVE_PROCESS_URL" });
        dispatch({ type: "REMOVE_USER" });
        dispatch({ type: "REMOVE_ID_PAYMENT" });
        dispatch({ type: "REMOVE_KEYS" });
        if (type === "inscripciones") {
          dispatch({ type: "REMOVE_PAGADOR" });
          dispatch({ type: "REMOVE_OPCIONES" });
          dispatch({ type: "REMOVE_GRADOS" });
        }
        if (type === "matricula") {
          dispatch({ type: "REMOVE_OPCIONES" });
        }
        navigate("/");
      }
    });
  };

  const cambiarPassword = () => {
    Swal.fire({
      title: '<span style="color:#0d1b3e;font-size:1.15rem;font-weight:700;">🔐 Cambiar Contraseña</span>',
      html: `
        <div style="text-align:left;font-size:.88rem;">
          <div style="margin-bottom:12px;">
            <label style="font-weight:600;color:#333;display:block;margin-bottom:4px;">Contraseña actual</label>
            <div style="position:relative;">
              <input id="swal-old" type="password" class="swal2-input" placeholder="Ingrese contraseña actual" style="width:100%;box-sizing:border-box;padding-right:40px;margin:0;" />
              <span id="eye-old" onclick="(function(){var i=document.getElementById('swal-old');var e=document.getElementById('eye-old');if(i.type==='password'){i.type='text';e.textContent='🙈';}else{i.type='password';e.textContent='👁';}})();" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);cursor:pointer;font-size:1.1rem;user-select:none;">👁</span>
            </div>
          </div>
          <div style="margin-bottom:12px;">
            <label style="font-weight:600;color:#333;display:block;margin-bottom:4px;">Nueva contraseña</label>
            <div style="position:relative;">
              <input id="swal-new" type="password" class="swal2-input" placeholder="Ingrese nueva contraseña" style="width:100%;box-sizing:border-box;padding-right:40px;margin:0;" oninput="(function(){var n=document.getElementById('swal-new').value;var c=document.getElementById('swal-confirm').value;var bar=document.getElementById('str-bar');var txt=document.getElementById('str-text');var match=document.getElementById('match-ind');var s=0;if(n.length>=6)s++;if(n.length>=10)s++;if(/[A-Z]/.test(n))s++;if(/[0-9]/.test(n))s++;if(/[^A-Za-z0-9]/.test(n))s++;var colors=['#e53935','#ff9800','#ffc107','#8bc34a','#2e7d32'];var labels=['Muy débil','Débil','Regular','Fuerte','Muy fuerte'];var pct=[20,40,60,80,100];bar.style.width=pct[Math.max(0,s-1)]+'%';bar.style.background=colors[Math.max(0,s-1)];txt.textContent=n.length>0?labels[Math.max(0,s-1)]:'';txt.style.color=colors[Math.max(0,s-1)];if(c.length>0&&n.length>0){match.textContent=n===c?'✅ Las contraseñas coinciden':'❌ Las contraseñas no coinciden';match.style.color=n===c?'#2e7d32':'#e53935';}else{match.textContent='';}})();" />
              <span id="eye-new" onclick="(function(){var i=document.getElementById('swal-new');var e=document.getElementById('eye-new');if(i.type==='password'){i.type='text';e.textContent='🙈';}else{i.type='password';e.textContent='👁';}})();" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);cursor:pointer;font-size:1.1rem;user-select:none;">👁</span>
            </div>
            <div style="margin-top:6px;height:6px;background:#e0e0e0;border-radius:3px;overflow:hidden;">
              <div id="str-bar" style="height:100%;width:0;border-radius:3px;transition:all .35s;"></div>
            </div>
            <div id="str-text" style="font-size:.78rem;font-weight:600;margin-top:3px;min-height:16px;"></div>
          </div>
          <div style="margin-bottom:12px;">
            <label style="font-weight:600;color:#333;display:block;margin-bottom:4px;">Confirmar nueva contraseña</label>
            <div style="position:relative;">
              <input id="swal-confirm" type="password" class="swal2-input" placeholder="Confirme nueva contraseña" style="width:100%;box-sizing:border-box;padding-right:40px;margin:0;" oninput="(function(){var n=document.getElementById('swal-new').value;var c=document.getElementById('swal-confirm').value;var match=document.getElementById('match-ind');if(c.length>0&&n.length>0){match.textContent=n===c?'✅ Las contraseñas coinciden':'❌ Las contraseñas no coinciden';match.style.color=n===c?'#2e7d32':'#e53935';}else{match.textContent='';}})();" />
              <span id="eye-confirm" onclick="(function(){var i=document.getElementById('swal-confirm');var e=document.getElementById('eye-confirm');if(i.type==='password'){i.type='text';e.textContent='🙈';}else{i.type='password';e.textContent='👁';}})();" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);cursor:pointer;font-size:1.1rem;user-select:none;">👁</span>
            </div>
            <div id="match-ind" style="font-size:.8rem;font-weight:600;margin-top:5px;min-height:18px;"></div>
          </div>
          <div style="background:#f5f7fa;border-radius:8px;padding:10px 14px;border-left:3px solid #d4a017;">
            <div style="font-weight:700;color:#0d1b3e;margin-bottom:4px;font-size:.82rem;">💡 Recomendaciones de seguridad</div>
            <ul style="margin:0;padding-left:18px;color:#555;font-size:.78rem;line-height:1.7;">
              <li>Mínimo <b>6 caracteres</b> (recomendado 10+)</li>
              <li>Incluir al menos una <b>letra mayúscula</b> (A-Z)</li>
              <li>Incluir al menos un <b>número</b> (0-9)</li>
              <li>Incluir un <b>carácter especial</b> (!@#$%&*)</li>
              <li>No usar datos personales (nombre, cédula)</li>
            </ul>
          </div>
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonColor: "#0d1b3e",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Cambiar contraseña",
      cancelButtonText: "Cancelar",
      width: 480,
      preConfirm: () => {
        const oldPass = document.getElementById("swal-old").value;
        const newPass = document.getElementById("swal-new").value;
        const confirmPass = document.getElementById("swal-confirm").value;
        if (!oldPass || !newPass || !confirmPass) {
          Swal.showValidationMessage("Todos los campos son obligatorios");
          return false;
        }
        if (newPass !== confirmPass) {
          Swal.showValidationMessage("Las contraseñas no coinciden");
          return false;
        }
        if (newPass.length < 6) {
          Swal.showValidationMessage("La contraseña debe tener al menos 6 caracteres");
          return false;
        }
        return { oldPass, newPass };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Contraseña actualizada",
          text: "Su contraseña ha sido cambiada exitosamente.",
          confirmButtonColor: "#0d1b3e",
        });
      }
    });
  };

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
      }}
      open={open}
    >
      {/* Close button */}
      <div className={classes.toolbarIcon}>
        {open && (
          <IconButton onClick={() => setOpen(false)} style={{ color: "rgba(255,255,255,0.6)" }}>
            <ChevronLeftIcon />
          </IconButton>
        )}
      </div>

      {/* ANAI Logo */}
      {open && (
        <div className={classes.logoSection}>
          <img src={logoanai} alt="ANAI" className={classes.logoImg} />
        </div>
      )}

      {/* User section */}
      <div className={clsx(classes.userSection, !open && classes.userSectionCollapsed)}>
        <div className={classes.userAvatar}>
          <PersonIcon style={{ fontSize: open ? 28 : 22, color: "#0d1b3e" }} />
        </div>
        {open && (
          <>
            <div className={classes.userName}>{username}</div>
            <div className={classes.userRole}>{sectionLabel}</div>
            {/* Profile & Logout actions below cedula */}
            <div className={classes.userActions}>
              <div className={classes.userActionBtn} onClick={cambiarPassword}>
                <LockIcon style={{ fontSize: "0.9rem" }} />
                <span>Perfil</span>
              </div>
              <div className={clsx(classes.userActionBtn, classes.userActionBtnDanger)} onClick={cerrarSesion}>
                <ExitToAppIcon style={{ fontSize: "0.9rem" }} />
                <span>Salir</span>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Navigation */}
      <div className={classes.navSection}>
        {open && <div className={classes.navLabel}>Navegación</div>}
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = currentPath === item.path;
          return (
            <Tooltip key={item.path} title={!open ? item.label : ""} placement="right">
              <div
                className={clsx(
                  classes.navItem,
                  isActive && classes.navItemActive,
                  !open && classes.navItemCollapsed
                )}
                onClick={() => navigate(item.path)}
              >
                <span className={clsx(classes.navIcon, !open && classes.navIconCollapsed)}>
                  <Icon fontSize="inherit" />
                </span>
                {open && <span className={classes.navText}>{item.label}</span>}
              </div>
            </Tooltip>
          );
        })}
      </div>

      {/* Collapsed logout */}
      {!open && (
        <div className={classes.logoutSection}>
          <Tooltip title="Cerrar sesión" placement="right">
            <div
              className={clsx(classes.logoutBtn, classes.logoutBtnCollapsed)}
              onClick={cerrarSesion}
            >
              <ExitToAppIcon style={{ fontSize: "1.1rem" }} />
            </div>
          </Tooltip>
        </div>
      )}
    </Drawer>
  );
};

export default Menu;
